export default __webpack_public_path__ + "static/media/icon_close_toast.d527cc94.svg";